import {createElement, Component, PropTypes} from 'rlink-react';
import TextContentInput from './TextContentInput';


export default class NumberInput extends TextContentInput {
  constructor (props, context) {
    super(props, context);
    this.attributes = {
      min: this.min,
      max: this.max,
    };
  }

  get min () {
    return this.fromPropsOrContext('min');
  }

  get max () {
    return this.fromPropsOrContext('max');
  }

  normalizeValue (value) {
    if (value !== null && value !== undefined && value !== false) {
      return Number(value);
    } else {
      return value;
    }
  }

  hasValue (value) {
    return !isNaN(this.normalizeValue(value));
  }

  get inputType () {
    return 'number';
  }

}



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/NumberInput.jsx